import { createElementBlock as n, openBlock as o, renderSlot as r } from "vue";
import t from "./index231.js";
const s = {}, c = {
  class: "underline",
  "data-component": "MsUnderline"
};
function l(e, a) {
  return o(), n("span", c, [
    r(e.$slots, "default")
  ]);
}
const f = /* @__PURE__ */ t(s, [["render", l]]);
export {
  f as default
};
